
/**
 * Michi Links Shop - minimal theme JS
 * - Password visibility toggle (login gate)
 * - Sort selector (collection/search)
 * - Auto-submit filters
 */
(function () {
  'use strict';

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-toggle-password]');
    if (btn) {
      var inputId = btn.getAttribute('data-toggle-password');
      var input = document.getElementById(inputId);
      if (!input) return;
      var isHidden = input.getAttribute('type') === 'password';
      input.setAttribute('type', isHidden ? 'text' : 'password');
      btn.setAttribute('aria-pressed', isHidden ? 'true' : 'false');
      return;
    }
  });

  // Sort selector: <select data-sort-by>
  document.addEventListener('change', function (e) {
    var select = closest(e.target, 'select[data-sort-by]');
    if (!select) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      // Reset page param when changing sort
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    } catch (_) {}
  });

  // Auto-submit filter forms
  document.addEventListener('change', function (e) {
    var input = closest(e.target, 'form[data-filters-form] input, form[data-filters-form] select');
    if (!input || !input.form) return;
    if (typeof input.form.requestSubmit === 'function') {
      input.form.requestSubmit();
    } else {
      input.form.submit();
    }
  });
})();
